/* eslint-disable */
import styles from './login.module.css';
import { Link } from 'react-router-dom'
import FacebookButton from '../../components/FacebookButton';
import UserProfile from '../UserProfile/UserProfile';
import Home from '../Home';

export default function Login({ setUser, setPassword, setLogin, userLoged }) {

  const submitLogin = (event) => {
    event.preventDefault()
    setLogin(true)
  }

  return (
    <>
      {
        userLoged ? (
          <Home />
        ) : (
          <>
            <div className={styles.loginConteiner}>
              <form onSubmit={submitLogin}>
                <img src='./elaele.png' alt='elaele icon' />
                <div className={styles.firstInputGroup}>
                  <input type='text' placeholder='E-mail ou usuário' className='f-g-input' required
                    onChange={
                      (e) => { setUser(e.target.value) }
                    }
                  />
                  <input type='password' placeholder='Senha' className='f-g-input' required
                    onChange={
                      (e) => { setPassword(e.target.value) }
                    }
                  />
                  <div className={styles.subLogin}>
                    <div>
                      <a href='https://elaele.com.br/esqueceu-senha.html'>Esqueceu a senha?</a>
                      <input type='checkbox' id='remember' />
                      <label htmlFor='remember' >Lembrar de mim</label>
                    </div>
                    <div className={styles.lineDiv}>
                    </div>
                  </div>
                  <input type='submit' value='Entrar' />
                  <h2>Ou</h2>
                  <FacebookButton />
                  <Link to='/singup'>Não possuo uma conta</Link>
                </div>
              </form>
            </div>
          </>
        )
      }
    </>
  )
}